// Chapter Action Types
export const CHAPTER_TAB_CLICKED = 'Chapter Tab Clicked';
export const CHAPTER_CLICKED = 'Chapter Clicked';
export const CHAPTER_SEEKED = 'Chapter Seeked';
export const SEEKBAR_CLICKED = 'Seekbar Clicked';
export const CHAPTER_ADD_CLICKED = 'Chapter Add Clicked';
export const CHAPTER_ADDED = 'Chapter Added';
export const CHAPTER_DELETED = 'Chapter Deleted';
export const CHAPTER_EDITED = 'Chapter Edited';
export const CHAPTER_FORM_OPENED = 'Chapter Form Opened';
export const CHAPTER_FORM_CANCELLED = 'Chapter Form Cancelled';
export const EDIT_CHAPTERS_CLICKED = 'Edit Chapters Clicked';
export const CHAPTER_SAVED = 'Chapter Saved';
export const CHAPTER_NAVIGATION_CLICKED = 'Chapter Navigation Clicked';
